import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const submissionFlowPlugin = createPlugin({
  id: 'submission-flow',
  routes: {
    root: rootRouteRef,
  },
});

export const SubmissionFlowPage = submissionFlowPlugin.provide(
  createRoutableExtension({
    name: 'SubmissionFlowPage',
    component: () =>
      import('./components/SubmissionFlowPage').then(
        m => m.SubmissionFlowPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
